import { opalStyle } from './stylesByFamily/opal/index.js';
/**
 *
 * @param theme Theme name
 * @param font Font name
 * @returns the font weights to use for a given theme and font
 */
export function getTypographyStyles(theme, font) {
    return opalStyle(font);
}
//# sourceMappingURL=typographyStyles.js.map